import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { getProductReviewListReset } from '../../../../actionCreators/review';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import PDPAccordian from '../PDPAccordian';
import ProductDetailNew from '../ProductDetailNew';
import ReviewList from '../Review/ReviewList';
import ProductRichContent from './../../../../CommonComponents/ProductRichContent';
import InfoModalComponent from './../../../components/Common/InfoModalComponent';
import ContactLenses from './../../../components/Product/ContactLenses/ContactLenses';
import SelectPowerTypes from './../../../components/Product/SideBar/SelectPowerTypes';
import Fbpixel from './../FbPixel';
import TiktokPixel from './../TiktokPixel';
import OutOfStock from './LoadableOutOfStock';
import './SideBar.scss';
// const ProductRichContent = lazy(() => import('./../../../../CommonComponents/ProductRichContent'));

class SideBar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      shortlistFull: false,
      showReview: { showReviewModal: false, writeMode: false },
      showProductRichContent: false,
      isScrollDown: false
    };
    this.isExchange =
      (sessionStorageHelper.getItem('exchangeMethod') === 'NEWPRODUCT' &&
        sessionStorageHelper.getItem('exchangeNP') === true) ||
      null;
    this.isYotpoWidgetsShow = this.isYotpoWidgetsShow.bind(this);
  }
  componentDidMount() {
    window.addEventListener('scroll', () => {
      if (!this.state.isScrollDown && window.pageYOffset > 20) this.setState({ isScrollDown: true });
    });

    setTimeout(() => {
      this.enableProductRichContent();
    }, 1000);
  }
  componentWillUnmount() {
    getProductReviewListReset();
  }
  setShortlistFull = () => {
    this.setState({ shortlistFull: !this.state.shortlistFull });
  };
  enableProductRichContent = () => {
    this.setState({ showProductRichContent: true });
  };
  isShortListErrWinClosed = () => {
    this.setState({ shortlistFull: false });
  };
  isYotpoWidgetsShow() {
    const { isYotpoWidgets, commonApiCall } = this.props;
    if (!isYotpoWidgets) {
      commonApiCall.setYotpoWidgetsState({ isYotpoWidgets: true });
    }
  }
  showReviewFn(value) {
    const { showReview } = this.state;
    this.setState({
      showReview: { showReviewModal: !showReview.showReviewModal, writeMode: value },
    });
  }
  render() {
    const {
      localeInfo,
      productData,
      showFAQTab,
      shortListData,
      currencyMark,
      modifiedProductData,
      productId,
      setWishList,
      sizeShown,
      productApiCall,
      productPriceWithGst,
      contactLensPowerFromUrl,
      frameType,
      triggerFbEventOnClick,
      frameShape,
      frameSize,
      getCmsPageData,
      cmsPopUpData,
      dataLocale,
      redisCommonData,
      shortListLoading,
      history,
      login,
      userInfo,
      exchangePrice,
    } = this.props;
    const { shortlistFull, showReview, showProductRichContent, isScrollDown } = this.state;
    const { showReviewModal, writeMode } = showReview;
    const { PDP_CONFIG, REVIEW_CONFIG, EXCHANGE_CONFIG } = redisCommonData;
    const reviewConfig = REVIEW_CONFIG ? JSON.parse(REVIEW_CONFIG) : {};
    const pdpConfig = PDP_CONFIG ? JSON.parse(PDP_CONFIG) : {};
    const { YOU_CAN_SHORTLIST_UPTO_50, SHORTLIST_LIMIT_REACHED } = dataLocale;
    const currencyCode =
      productData.prices && productData.prices.length > 0 ? productData.prices[0].currencyCode : '';
    const displayPrice = modifiedProductData?.firstFrameFree
      ? modifiedProductData?.firstFrameFreePrice
      : modifiedProductData?.lenskartPrice;
    let exchangeFreeText;
    let exchangeText;
    if (this.isExchange && EXCHANGE_CONFIG) {
      const exchangeConfig = JSON.parse(redisCommonData.EXCHANGE_CONFIG);
      exchangeFreeText = exchangeConfig && exchangeConfig.EXCHANGE_FREE_TEXT;
      exchangeText = exchangeConfig && exchangeConfig.EXCHANGE_TEXT;
    }
    return (
      <div
        className="sidebar"
        onFocus={this.isYotpoWidgetsShow}
        onMouseOver={this.isYotpoWidgetsShow}
      >
        {shortlistFull && (
          <InfoModalComponent
            callback={() => {
              this.isShortListErrWinClosed();
            }}
            headerTitle={SHORTLIST_LIMIT_REACHED}
            msgContent={YOU_CAN_SHORTLIST_UPTO_50}
            msgType="info"
          />
        )}
        <Fbpixel
          content_category={productData.type}
          content_ids={productId}
          content_name={productData.fullName}
          currencyCode={currencyCode}
          value={productData.prices[1].price}
        />
        <TiktokPixel
          category={productData.type}
          currency={currencyCode}
          productId={productId}
          productName={productData.fullName}
          productPrice={productData.prices[1].price}
        />
        <ProductDetailNew
          cmsPopUpData={cmsPopUpData}
          contactLensPowerFromUrl={contactLensPowerFromUrl}
          currencyMark={currencyMark}
          dataLocale={dataLocale}
          displayPrice={displayPrice}
          exchangeFreeText={exchangeFreeText}
          exchangeText={exchangeText}
          frameShape={frameShape}
          frameSize={frameSize}
          frameType={frameType}
          getCmsPageData={getCmsPageData}
          history={history}
          isExchange={this.isExchange}
          localeInfo={localeInfo}
          login={login}
          productApiCall={productApiCall}
          productData={productData}
          productId={productId}
          productPriceWithGst={productPriceWithGst}
          redisCommonData={redisCommonData}
          setShortlistFull={this.setShortlistFull}
          setWishList={setWishList}
          shortListData={shortListData}
          shortListLoading={shortListLoading}
          showFAQTab={showFAQTab}
          sizeShown={sizeShown}
          triggerFbEventOnClick={triggerFbEventOnClick}
          userInfo={userInfo}
        />
        {productData.qty > 0 ? (
          [
            <SelectPowerTypes
              key="select-power"
              {...this.props}
              exchangePrice={exchangePrice}
              productData={productData}
            />,
            productData.type === 'Contact Lens' &&
            productData.classification !== 'contact_lens_solution' &&
            productData.classification !== 'accessories_revenue' ? (
              <ContactLenses key="contact-lenses" productData={productData} {...this.props} />
            ) : (
              ''
            ),
          ]
        ) : (
          <OutOfStock productData={productData} />
        )}
        <PDPAccordian
          cmsPopUpData={cmsPopUpData}
          dataLocale={dataLocale}
          getCmsPageData={getCmsPageData}
          productData={productData}
          showReview={value => this.showReviewFn(value)}
        />
        {isScrollDown && (
          <>
            {showReviewModal && (
              <ReviewList
                dataLocale={dataLocale}
                productData={productData}
                {...this.props}
                reviewConfig={reviewConfig}
                showReviewFn={value => this.showReviewFn(value)}
                writeMode={writeMode}
              />
            )}
            {!showProductRichContent && <div className="prod-img-container" />}
            {showProductRichContent &&
              pdpConfig.showPDPRich?.desktop === 'ON' &&
              productData.pdpContent && (
                <ProductRichContent productContent={productData.pdpContent} />
              )}
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  shortListData: state.common.shortListData,
  isTryOnSwitch: state.common.isTryOnSwitch,
  cmsPopUpData: state.common.cmsPopUpData,
  dataLocale: state.locale,
  currencyMark: state.common.currencyMark,
  redisCommonData: state.common.redisCommonData,
  modifiedProductData: state.product.modifiedProductData,
  shortListLoading: state.common.shortListLoading,
  login: state.common.login,
  userInfo: state.common.userInfo,
  localeInfo: state.common.localeInfo,
});

function mapDispatchToProps(dispatch) {
  return {
    getProductReviewListReset: bindActionCreators(getProductReviewListReset, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SideBar));
